import { getBuyOrder } from "./buyOrders";
import { sendBugsnagError } from "@utils/Bugsnag";
import { errorResponseMessage } from "./errorResponseMessage";
import { isSchemaError } from "./isSchemaError";

export const sendClaim = body => async (dispatch, getState, api) => {
  try {
    await api.post("v3/claims", body);
    const orderUUID = getState().orderAssistance.orderUUID;
    dispatch(getBuyOrder(orderUUID));
    return "success";
  } catch (error) {
    sendBugsnagError(error, "actions/sendClaim");
    let message = errorResponseMessage(error);
    if (isSchemaError(message)) {
      message = "Something went wrong, please refresh the page.";
    }
    return { error: message };
  }
};
